import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';
import {
  actionCreator,
  checkHttpStatus,
  GET_APPOINTMENT_DATA_API,
  jsonApiHeader,
  PATIENT_ENCOUNTERS_DETAILS_API,
  SAVE_PATIENTENCOUNTER_API,
  soapActionTypes,
  showErrorMessage,
  showSuccessMessage,
  SAVE_CLOCKIN_TIME_API,
  GET_MASTERDATABYNAME,
  SAVE_CLOCKOUT_TIME_API,
  GET_PATIENT_NON_BILLABLE_ENCOUNTER_DETAILS,
  SAVE_PATIENT_NON_BILLABLE_ENCOUNTER_DETAILS,
} from './../constants/ApiConstants';

export const getPatientEncounter = (appt_id, enc_id, isAdmin = false) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.get_patient_encounter.REQUEST));
    fetch(`${PATIENT_ENCOUNTERS_DETAILS_API}/${appt_id}/${enc_id}?isAdmin=${isAdmin}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.get_patient_encounter.SUCCESS, response));
      })
      .catch(function(error) {
        // dispatch(actionCreator(soapActionTypes.get_patient_soap.FAILURE));
        console.log('get_patient_encounter error', error);
      });
  };
};

// http://localhost:51269/patient-encounter/GetPatientNonBillableEncounterDetails
export const getPatientNonBillableEncounterDetails = (appt_id, enc_id, isAdmin = false) =>{
  
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.get_patient_non_billable_encounter.REQUEST));
    fetch(`${GET_PATIENT_NON_BILLABLE_ENCOUNTER_DETAILS}/${appt_id}/${enc_id}?isAdmin=${isAdmin}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.get_patient_non_billable_encounter.SUCCESS, response));
      })
      .catch(function(error) {
        // dispatch(actionCreator(soapActionTypes.get_patient_soap.FAILURE));
        console.log('getPatientNonBillableEncounterDetails error', error);
      });
  };
}

export const savePatientNonBillableEncounterDetails = (formData, isGenerateClaim, isAdmin = false) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.save_patient_non_billable_encounter.REQUEST));
    let requestType = 'post';
    let fetchAPI = `${SAVE_PATIENT_NON_BILLABLE_ENCOUNTER_DETAILS}?isAdmin=${isAdmin}`;

    fetch(fetchAPI, {
      method: requestType,
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          // if (isGenerateClaim && formData.Id) {
          //   dispatch(createClaimAction(formData.Id, isAdmin));
          // } else {
          //   showSuccessMessage(response.message);
          // }
          showSuccessMessage(response.message);
          dispatch(actionCreator(soapActionTypes.save_patient_non_billable_encounter.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(soapActionTypes.save_patient_non_billable_encounter.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('savePatientNonBillableEncounterDetails-----', error);
      });
  };
}

export const savePatientEncounter = (formData, isGenerateClaim, isAdmin = false) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.post_patient_encounter.REQUEST));
    let requestType = 'post';
    let fetchAPI = `${SAVE_PATIENTENCOUNTER_API}?isAdmin=${isAdmin}`;

    fetch(fetchAPI, {
      method: requestType,
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.post_patient_encounter.SUCCESS, response));
        let message = response.message;
        if (response.statusCode >= 200 && response.statusCode < 204) {
          showSuccessMessage(message);
        } else {
          showErrorMessage(message);
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };

};

export const getAppointmentById = (appointment_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.get_appointment_by_id.REQUEST));
    fetch(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.get_appointment_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get appointment_by_id error', error);
      });

  };
};


export const saveClockInTimeIntoAppointment = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.post_clockin_time.REQUEST));
    
    fetch(SAVE_CLOCKIN_TIME_API, {
      method: 'PATCH',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {          
          showSuccessMessage(response.message);          
          dispatch(actionCreator(soapActionTypes.post_clockin_time.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(soapActionTypes.post_clockin_time.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };

};


export const saveClockOutTimeIntoAppointment = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.post_clockout_time.REQUEST));
    
    fetch(SAVE_CLOCKOUT_TIME_API, {
      method: 'PATCH',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {          
          showSuccessMessage(response.message);          
          dispatch(actionCreator(soapActionTypes.post_clockout_time.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(soapActionTypes.post_clockout_time.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };

};

export const getMasterData = () => {
  return (dispatch, getState) => {
    // debugger;
    dispatch(actionCreator(soapActionTypes.get_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'SUPERVISIONTRAININGTITLE,SUPERVISIONTRAININGTITLEWITHOUTOJT' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get master data (soap actions) ..', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/scheduling/components/nonBillableSoap/actions/soapActions.js